const messages = {
  name: 'Tarifa |||| Tarifas',
  matrix: {
    hint: 'Coste en creditos por mensaje de cada canal para cada cuenta. Las celdas en negrita son precios personalizados; las atenuadas usan el default del canal. Escribe un valor para personalizar; borralo para volver al default. Se guarda al salir de la celda. Si eliges una tarifa prefijada, sus precios se aplican y las celdas quedan bloqueadas.',
    empty: 'No hay cuentas con centro de coste.',
    account: 'Cuenta',
    default: 'Default',
    tariff: 'Tarifa',
    noTariff: 'Sin tarifa (default)',
    filterAccount: 'Cuenta',
    application: 'Aplicacion',
    accountLevel: 'Nivel cuenta (todas)',
    inherit: 'Hereda de cuenta',
    inheritNamed: 'Hereda de cuenta (%{name})',
  },
  tariffs: {
    title: 'Tarifas prefijadas',
    hint: 'Define tarifas con un precio por canal y asignalas a las cuentas en la pantalla de pricing. Un canal vacio usa el default de la plataforma.',
    add: 'Nueva tarifa',
    name: 'Nombre',
    empty: 'Aun no hay tarifas prefijadas.',
    createTitle: 'Nueva tarifa',
    editTitle: 'Editar tarifa',
    pricesHint: 'Precio en creditos por canal. Deja un canal vacio para usar el default.',
    nameRequired: 'El nombre es obligatorio.',
    invalidPrice: 'Precio invalido en %{channel}.',
    saved: 'Tarifa guardada.',
    deleted: 'Tarifa eliminada.',
    confirmDelete: 'Eliminar la tarifa "%{name}"? Las cuentas que la usen volveran al pricing por defecto.',
  },
  fields: {
    costCenterId: 'Centro de Coste',
    applicationId: 'Aplicacion',
    communicationChannel: 'Canal de Comunicacion',
    pricePerUnit: 'Precio por Unidad',
    costCenterName: 'Centro de Coste',
    applicationName: 'Aplicacion',
  },
  empty: 'No hay tarifas',
  invite: 'Anade tu primera tarifa',
  filters: {
    costCenter: 'Centro de Coste',
    application: 'Aplicacion',
    communicationChannel: 'Canal de Comunicacion',
  },
  actions: {
    addPricing: 'Anadir Tarifa',
  },
  dialog: {
    title: 'Detalles de la Tarifa',
  },
  validation: {
    required: '%{field} es obligatorio',
    minValue: '%{field} debe ser mayor o igual a %{min}',
    positive: '%{field} debe ser mayor que 0',
  },
  create: { title: 'Crear Tarifa' },
  edit: { title: 'Editar Tarifa' },
  sections: {
    basicInfo: 'Detalles de la Tarifa',
  },
  delete: {
    title: 'Eliminar tarifa de "%{recordName}"',
    content: 'Estas seguro de que quieres eliminar esta tarifa? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Tarifa creada correctamente',
    updated: 'Tarifa actualizada correctamente',
    deleted: 'Tarifa eliminada correctamente',
  },
};

export default messages;
